import classes from "classnames";

export default (columns = 1, isFullWidth = false) => {
    const MAX_COLUMN_SPAN = 12;
    const columnSpan = MAX_COLUMN_SPAN / columns;
    const columnWidthClass = "medium-" + (isFullWidth ? MAX_COLUMN_SPAN : columnSpan);
    return classes("columns small-12", columnWidthClass);
};
